import React from "react"

import { InfoIcon } from "@atos6/icons"
import { Paragraph, Space } from "@atos6/ui"
import { Card } from "../App.styles"
import { useStore } from "../containers"

export function BoletoCell() {
  const { isAccountCreated } = useStore()

  return (
    <Card disabled={!isAccountCreated}>
      <Space size="large">
        <div style={{ width: 24, height: 24 }}>
          <InfoIcon />
        </div>
        <Paragraph>
          O recebimento de boleto bancário é liberado um dia útil após a confirmação do pagamento.
          <br />
          Taxa de R$ 3,75 por boleto pago - essa tarifa do boleto nao interfere por dia de
          recebimento
        </Paragraph>
      </Space>
    </Card>
  )
}
